import React, {useState} from 'react';
import {Button, Form, Input, message, Result} from 'antd';
import {useMutation} from 'react-query';
import {RestorePassword} from "../../../api/profile";


export const Recovery = ({token = ''}) => {
    const [success, setSuccess] = useState(false);
    const RestorePasswordMutation = useMutation(
        (data) => RestorePassword(data),
        {
            onSuccess: () => {
                setSuccess(true)
            },
            onError: (e) => {
                console.error(`[RestorePasswordMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const onFinish = (props) => {
        RestorePasswordMutation.mutate({...props, ...{token}});
    }

    return (
        <div className={`component sign_in`}>
            <h2>Сброс пароля</h2>
            {success === true && (
                <div className="sign_in--wrp">
                <Result
                    status={"success"}
                    title={"Ваш пароль успешно обновлен"}
                    subTitle={"Вы можете авторизоваться с новым паролем"}
                    extra={[<Button type={`primary`} onClick={() => window.location.href = '/profile/sign_in'}>Войти</Button> ]}
                />
                </div>
            )}
            {success === false && (
                <div className="sign_in--wrp">
                    {token !== '' && (
                        <Form layout={"vertical"} name={`sign_in`} onFinish={onFinish}>
                            <Form.Item
                                name="password"
                                label="Пароль"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Введите пароль',
                                    },
                                ]}
                                hasFeedback
                            >
                                <Input.Password/>
                            </Form.Item>

                            <Form.Item
                                name="confirm"
                                label="Повторите пароль"
                                dependencies={['password']}
                                hasFeedback
                                rules={[
                                    {
                                        required: true,
                                        message: 'Введите пароль',
                                    },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (!value || getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error('Ваши пароли должны совпадать'));
                                        },
                                    }),
                                ]}
                            >
                                <Input.Password/>
                            </Form.Item>
                            <Form.Item className={`sign_in--actions`}>
                                <Button type={`primary`} htmlType={"submit"} loading={RestorePasswordMutation.isLoading}>Сбросить
                                    пароль</Button>
                            </Form.Item>
                        </Form>
                    )}
                    {token === '' && (
                        <Result
                            status={"error"}
                            title={"Сессия восстановления не найдена"}
                            subTitle={"Проверьте ваш почтовый ящик и перейдите по ссылке в письме"}
                        />
                    )}

                </div>
            )}
        </div>
    );
};

export default Recovery;